import baseQuestions from "./questions.en";
import { translateDiagnostic } from "../i18n/translate";

const lang = "ja";
const t = (text) => translateDiagnostic(lang, text);

const translateOption = (opt) => {
  if (typeof opt === "string") return t(opt);
  if (opt && typeof opt === "object") {
    const next = { ...opt };
    if (typeof next.answer === "string") next.answer = t(next.answer);
    return next;
  }
  return opt;
};

const questions = baseQuestions.map((q) => {
  const next = { ...q };
  if (typeof next.question === "string") next.question = t(next.question);

  if (Array.isArray(next.options)) {
    next.options = next.options.map(translateOption);
  }

  if (Array.isArray(next.subQuestions)) {
    next.subQuestions = next.subQuestions.map((sq) => ({
      ...sq,
      label: typeof sq.label === "string" ? t(sq.label) : sq.label,
    }));
  }

  return next;
});

export default questions;

